import React, { FC } from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { AiOutlineMinusCircle } from "react-icons/ai";

interface AccordionItem {
    title: string;
    description: string;
}

interface AccordionProps {
    title: string;
    items: AccordionItem[];
}

const Accordion: FC<AccordionProps> = ({ items, title: groupTitle }) => {
    return (
        <div className="py-5">
            {items.map((item, index) => {
                return (
                    <div key={item.title} className="tab w-full overflow-hidden">
                        <input className="absolute hidden" id={`tab-${item.title}`} type="radio" name={groupTitle} defaultChecked={index === 0} />
                        <label className="flex w-full leading-normal text-base cursor-pointer py-1" htmlFor={`tab-${item.title}`}>
                            <h4 className="flex-1 text-lg">{item.title}</h4>
                            <div className="expand-toggle-icon rounded-full flex items-center p-1">
                                <div className="plus-icon">
                                    <AiOutlinePlusCircle size="24" />
                                </div>
                                <div className="minus-icon">
                                    <AiOutlineMinusCircle size="24" />
                                </div>
                            </div>
                        </label>
                        <div className="tab-content overflow-hidden">
                            <p className="pb-2 pr-5 text-base text-gray-500 leading-relaxed">{item.description}</p>
                        </div>
                        <div className="py-2">
                            <div style={{ border: "1px solid #E5E7EB" }} />
                        </div>
                    </div>
                );
            })}
            <style jsx>
                {`
                    .tab-content {
                        height: 0;

                        -webkit-transition: all 200ms ease-in;
                        -o-transition: all 200ms ease-in;
                        transition: all 200ms ease-in;
                    }

                    .tab input:checked ~ .tab-content {
                        height: 95px;
                    }

                    @media (min-width: 768px) {
                        .tab input:checked ~ .tab-content {
                            height: 75px;
                        }
                    }

                    .tab input + label {
                        transition: all 200ms ease-in;
                        color: #666666;
                        font-weight: 400;
                    }

                    .tab input + label:hover {
                        color: #333333;
                    }

                    .tab input + label > .expand-toggle-icon {
                        transition: all 200ms ease-in;
                        color: #3364fa;
                        font-size: 1.25rem;
                    }

                    .tab input:checked + label {
                        color: #000;
                        font-weight: 500;
                    }

                    .tab input + label:hover > .expand-toggle-icon {
                        background-color: #ececec;
                    }

                    .tab input:checked + label > .expand-toggle-icon {
                        background-color: #ececec;
                        transform: rotate(-180deg);
                    }
                    .tab input + label > .expand-toggle-icon .minus-icon,
                    .tab input:checked + label > .expand-toggle-icon .plus-icon {
                        display: none;
                    }

                    .tab input:checked + label > .expand-toggle-icon .minus-icon {
                        display: block;
                    }
                `}
            </style>
        </div>
    );
};

export default Accordion;
